// extracted by mini-css-extract-plugin
export default {"toggler_absolute":"Toggler-module__toggler_absolute___fIATQ","toggler_closed":"Toggler-module__toggler_closed___hAwUm"};